module.exports = __webpack_public_path__ + "img/18.eaf2810e.webp";